import React from 'react';

const SacredGeometry = ({ opacity = 0.03, className = '' }) => {
  return (
    <svg
      className={`absolute inset-0 w-full h-full ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800 800"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        <linearGradient id="purpleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#8b5cf6', stopOpacity: opacity }} />
          <stop offset="100%" style={{ stopColor: '#c084fc', stopOpacity: opacity }} />
        </linearGradient>
      </defs>
      
      {/* Metatron's Cube - simplified version */}
      <g transform="translate(400, 400)" opacity={opacity}>
        {/* Outer circle */}
        <circle cx="0" cy="0" r="200" fill="none" stroke="url(#purpleGradient)" strokeWidth="1" />
        
        {/* Inner circles forming the pattern */}
        <circle cx="0" cy="0" r="100" fill="none" stroke="url(#purpleGradient)" strokeWidth="1" />
        <circle cx="0" cy="-100" r="50" fill="none" stroke="url(#purpleGradient)" strokeWidth="0.5" />
        <circle cx="86.6" cy="-50" r="50" fill="none" stroke="url(#purpleGradient)" strokeWidth="0.5" />
        <circle cx="86.6" cy="50" r="50" fill="none" stroke="url(#purpleGradient)" strokeWidth="0.5" />
        <circle cx="0" cy="100" r="50" fill="none" stroke="url(#purpleGradient)" strokeWidth="0.5" />
        <circle cx="-86.6" cy="50" r="50" fill="none" stroke="url(#purpleGradient)" strokeWidth="0.5" />
        <circle cx="-86.6" cy="-50" r="50" fill="none" stroke="url(#purpleGradient)" strokeWidth="0.5" />
        
        {/* Connecting lines */}
        <line x1="0" y1="-100" x2="0" y2="100" stroke="url(#purpleGradient)" strokeWidth="0.5" />
        <line x1="-86.6" y1="-50" x2="86.6" y2="50" stroke="url(#purpleGradient)" strokeWidth="0.5" />
        <line x1="-86.6" y1="50" x2="86.6" y2="-50" stroke="url(#purpleGradient)" strokeWidth="0.5" />
        
        {/* Hexagon */}
        <path
          d="M 0,-100 L 86.6,-50 L 86.6,50 L 0,100 L -86.6,50 L -86.6,-50 Z"
          fill="none"
          stroke="url(#purpleGradient)"
          strokeWidth="0.5"
        />
      </g>
    </svg>
  );
};

export default SacredGeometry;
